import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import DeleteIcon from '@mui/icons-material/Delete';
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import { useTranslation } from 'react-i18next';

import BlockFrostedBackgroundButton from 'src/pages/Dashboard/System/Pages/components/BlockFrostedBackgroundButton';
import BlockSpacingButton from 'src/pages/Dashboard/System/Pages/components/BlockSpacingButton';
import BlockVisibilityRulesButton from 'src/pages/Dashboard/System/Pages/components/BlockVisibilityRulesButton';
import { IBlockSpacing, IVisibilityFilter } from 'src/interfaces/PageBlock';

interface BlockCardToolbarProps {
  showFrostedBackground?: boolean;
  frostedBackground?: boolean;
  onFrostedBackgroundChange?: (enabled: boolean) => void;
  showVisibilityRules?: boolean;
  visibility?: IVisibilityFilter;
  onVisibilityChange?: (value: IVisibilityFilter | undefined) => void;
  spacing?: IBlockSpacing;
  onSpacingChange?: (value: IBlockSpacing | undefined) => void;
  isDividerBlock?: boolean;
  showSignupPresets?: boolean;
  canMoveUp: boolean;
  canMoveDown: boolean;
  onMoveUp: () => void;
  onMoveDown: () => void;
  onRemove: () => void;
  canRemove?: boolean;
}

export default function BlockCardToolbar({
  showFrostedBackground = false,
  frostedBackground = false,
  onFrostedBackgroundChange,
  showVisibilityRules = true,
  visibility,
  onVisibilityChange,
  spacing,
  onSpacingChange,
  isDividerBlock = false,
  showSignupPresets = false,
  canMoveUp,
  canMoveDown,
  onMoveUp,
  onMoveDown,
  onRemove,
  canRemove = true,
}: BlockCardToolbarProps) {
  const { t } = useTranslation();

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', flexShrink: 0 }}>
      {showFrostedBackground && onFrostedBackgroundChange ? (
        <BlockFrostedBackgroundButton
          enabled={frostedBackground === true}
          onChange={onFrostedBackgroundChange}
        />
      ) : null}
      {showVisibilityRules && onVisibilityChange ? (
        <BlockVisibilityRulesButton
          value={visibility}
          onChange={onVisibilityChange}
          showSignupPresets={showSignupPresets}
        />
      ) : null}
      {onSpacingChange ? (
        <BlockSpacingButton
          value={spacing}
          onChange={onSpacingChange}
          isDividerBlock={isDividerBlock}
        />
      ) : null}
      <IconButton
        size="small"
        disabled={!canMoveUp}
        onClick={onMoveUp}
        aria-label={t('system.pages.moveBlockUp')}
      >
        <ArrowUpwardIcon fontSize="small" />
      </IconButton>
      <IconButton
        size="small"
        disabled={!canMoveDown}
        onClick={onMoveDown}
        aria-label={t('system.pages.moveBlockDown')}
      >
        <ArrowDownwardIcon fontSize="small" />
      </IconButton>
      <IconButton
        size="small"
        disabled={!canRemove}
        onClick={onRemove}
        aria-label={t('base.delete')}
      >
        <DeleteIcon fontSize="small" />
      </IconButton>
    </Box>
  );
}
